import * as Sentry from '@sentry/react';

const sentryDSN = window.env.REACT_SENTRY_DSN;
const sentryURL = window.env.REACT_SENTRY_URL;
const sentryID = window.env.REACT_SENTRY_ID;

export const useSentry = (): void => {
    const dsn = `https://${sentryDSN}@${sentryURL}/${
        sentryID
    }`;
    const urlParams = new URLSearchParams(window.location.search);
    Sentry.init({
        dsn: dsn,
        integrations: [],
        beforeSend(event) {
            event.tags = {
                ...event.tags,
                'screen.width': window.innerWidth.toString(),
                'screen.height': window.innerHeight.toString(),
                operatorId: urlParams.get('operator'),
                currency: urlParams.get('currency'),
                lang: urlParams.get('lang'),
                gameMode: urlParams.get('gameMode'),
            };
            return event;
        },
    });
};
